const swiperOptions = {
  loop: true,
  allowTouchMove: false,
  speed: 4000,
  freeMode: true,
  centeredSlides: true,
  autoplay: {
    delay: 100,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2.5,
      spaceBetween: 0,
    },
    992: {
      slidesPerView: 8,
      spaceBetween: 33,
    },
  },
};

const swiper = new Swiper(
  ".verist-logo-gallery__section .swiper-container",
  swiperOptions
);
